import React, { FC, useContext, useEffect } from 'react';
import styles from './ErrorBlock.scss';
import { classnames } from '@src/utils/classnames';
import { Notification } from '@src/atoms/Notification';
import { UploaderContext } from '../context';
import { AppContext } from '@src/providers/App';
import { ERROR_CONTENS, ERROR_TITLES } from './consts';

export interface IErrorBlockProps {
  errorCode: string;
  fileList: string[];
  maxFiles: number;
  maxFileSizeMB: number;
  acceptedFiles: string;
}

export const ErrorBlock: FC<IErrorBlockProps> = ({ errorCode, fileList, maxFiles, maxFileSizeMB, acceptedFiles }) => {
  const { controller, isMulti } = useContext(UploaderContext);
  const { setNotification } = useContext(AppContext);

  const title = ERROR_TITLES[errorCode](fileList.length);
  const content = ERROR_CONTENS(acceptedFiles, maxFileSizeMB, maxFiles)[errorCode](fileList);

  const classes = classnames(styles.root, styles.width);

  const handleClose = () => {
    controller.errorsMap.delete(errorCode);
    controller.setStateErrors(new Map(controller.errorsMap));
  };

  useEffect(() => {
    if (!isMulti) {
      setNotification({
        view: 'error',
        content,
      });
    }
  }, [content, isMulti, setNotification]);
  if (!isMulti) return null;
  return (
    <Notification mode={'banner'} view={'error'} title={title} className={classes} onClose={handleClose}>
      {content}
    </Notification>
  );
};
